import { InputNumber, Space } from "antd";
import { Dropdown, IDropdownOption } from "office-ui-fabric-react";
import { SET_TYPE_RIGHTS_LOOKUP, SET_TYPE_LOOKUP, AGENCY_LOOKUP, TERRITORY_LOOKUP } from "../../../../lookup/Consts";
import { mapLookupKey, getLookupValues, mapUsageLookupKey } from "../../../../lookup/services/LookupHelpers";
import { EDITABLE_FIELDS, TEXT_INPUT, ARTISTS_KEY, WORK_ARTIST_NUMBER_KEY, INTEGER_PERCENTAGE_INPUT, INTEGER_INPUT, READ_ONLY_INPUT, DROPDOWN_INPUT, USAGE_DETAILS_ROWS_SECTION_KEY, DISTRIBUTION_POOL_CODE_STATE_KEY, IP_REPRESENTATION_KEY, PAYMENTRUN_DISTRIBUTION_CODE_STATE_KEY, USAGE_DETAILS_ROWS_INBOUNDFEESINERROR, USAGE_DETAILS_ROWS_OUTBOUNDFEESINERROR, EMPTY_STRING_VALUE, WORKNUMBER_CORE_OR_EXTERNAL_BOTH, WORKNUMBER_CORE_OR_EXTERNAL_CORE, DATE_INPUT, TIME_INPUT, TIMESPAN_INPUT, READ_ONLY_TIMESPAN_INPUT, BOOLEAN_READONLY_INPUT, CHECKBOX_INPUT, TOGGLE_BUTTON, CUSTOM_INPUT, DROPDOWN_TREE_INPUT, LINK_INPUT, IP_NAME_NUMBER_STATE_KEY, ECONOMIC_RIGHT, MATCHING_REPERTOIRE_PRODUCTS_KEY, MATCHING_REPERTOIRE_WORKS_KEY, TEXT_READONLY_IN_REPERTOIRE_INPUT } from "../../../Consts";
import { RepertoireHelper } from "../../../services/RepertoireHelper";
import { ITreeData } from "../../../types/ITreeData";
import BooleanReadonlyDisplay from "../../checkboxDataInput/BooleanReadonlyDisplay";
import CheckboxDataInput from "../../checkboxDataInput/CheckboxDataInput";
import DataGridTableSection from "../../dataGridTableSection/DataGridTableSection";
import DateDisplay from "../../dateDisplay/DateDisplay";
import DropdownDataInput from "../../dropdownDataInput/DropdownDataInput";
import DropdownTreeDataInput from "../../dropdownTreeDataInput/DropdownTreeDataInput";
import IconTextButton from "../../iconTextButton/IconTextButton";
import TextDataInput from "../../textDataInput/TextDataInput";
import FormattedTimeDataInput from "../../timeFieldDataInput/FormattedTimeDataInput";
import SimpleTimeDataInput from "../../timeFieldDataInput/SimpleTimeDataInput";
import { ToggleButtonDataInput } from "../../toggleInput/ToggleInput";
import { IDataGridTableProps } from "../DataGridTable";
import IPRoleSelector from "../IPRoleSelector";
import { DataSource } from "../../../types/DataSource";
import SizedDateDataInput from "../../../components/dateDataInput/DateDataInput";

export const getMaxLength = (fieldName: string) => {
    switch (fieldName) {
        case "seriesIdentifier": {
            return 4;
        }
        case "productionNumber": {
            return 12;
        }
        case "episodeNumber": {
            return 20;
        }
        case "vIsan": {
            return 26;
        }
        default: {
            return undefined;
        }
    };
}

export const handleKeyDown = (e) => {
    if (
        (e.key >= '0' && e.key <= '9') ||
        e.key === 'Backspace' ||
        e.key === 'ArrowLeft' ||
        e.key === 'ArrowRight' ||
        e.key === 'Tab' ||
        e.key === '.'
    ) {
        return;
    }

    e.preventDefault();
};

interface InputTypeDataParams {
    tableContentItem: any;
    fieldType: string;
    stateKey: string;
    dataSource: string;
}

const setUpValueAndInputType = ({
    tableContentItem,
    fieldType,
    stateKey,
    dataSource,
}: InputTypeDataParams): { value: any; type: string } => {
    if (tableContentItem === undefined) {
        tableContentItem = { value: '', inputType: '' };
    }

    let { value, inputType } = Array.isArray(tableContentItem)
        ? { value: '', inputType: '' }
        : tableContentItem;

    if (!value && !inputType) {
        value = tableContentItem;
        inputType = fieldType;
    }

    if (
        Array.isArray(tableContentItem) &&
        (stateKey === MATCHING_REPERTOIRE_WORKS_KEY || stateKey === MATCHING_REPERTOIRE_PRODUCTS_KEY)
    ) {
        inputType = tableContentItem.length >= 1 ? tableContentItem[0].inputType : 'readonly';
    }

    let type = inputType;
    if (inputType === TEXT_READONLY_IN_REPERTOIRE_INPUT) {
        type = dataSource === DataSource.Intray ? TEXT_INPUT : READ_ONLY_INPUT;
    }

    return { value, type };
}

export const getDataInputType = (
    changeTableData: (value: any, stateKey: string, objectKey: string, rowIndex: number, componentInstance?: string) => void,
    props: IDataGridTableProps,
    tableContentItem: any,
    objectKey: string,
    rowIndex: number,
    fieldType = "",
    isHidden = false,
    divTitle = "",
    minValueForNumericField?: number,
    disabled = false,
): JSX.Element => {
    const {
        stateKey,
        lookupValues,
        showDropdownsAsCodes,
        dataSource,
        isReadOnly,
        componentInstance,
        customFields,
        tabs,
        activeTab,
        lookupSources,
        tableContents,
        poolCodes,
        distributionCodes,
        distributions,
        expandedWorkResults,
        expandedProductResults,
        onClickAddUsageDetails,
        portalType,
        isBackendSearchEnabled,
        onBackendSearch,
        customer,
        entity,
        openInNewTab,
        updateWorkField,
        datesAndDimensions,
        creationClassOptions
    } = props;


    let { type, value } = setUpValueAndInputType({
        tableContentItem,
        fieldType,
        stateKey,
        dataSource,
    });

    const multiSelectChangeData = (_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        updateWorkField(option.data, "workInstruments", rowIndex);
    }

    let isdisabledperfield = entity?.useRelationships;

    const tableCell = stateKey !== EDITABLE_FIELDS ? "tableCell" : "";

    switch (type) {

        case TEXT_INPUT:
            if (componentInstance === EDITABLE_FIELDS && objectKey === "defaultValue") {

                value = tableContentItem["defaultValue"];
                value = value ? value : '';

                return (
                    disabled ? <></> :
                        <div className={tableCell}>
                            <TextDataInput
                                value={value}
                                fieldName={stateKey}
                                changeData={(value, stateKey) =>
                                    changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)
                                }
                                readOnly={isReadOnly}
                                maxLength={getMaxLength(objectKey)}
                                isHidden={isHidden}
                            />
                        </div>
                );
            }
            else if (componentInstance === "avSubmissionDetails" && objectKey === "submissionDateTime") {
                return (<div className="tableCell">
                    <DateDisplay value={value} showTime={true} />
                </div>)
            }
            else {
                return (
                    <div className={tableCell}>
                        <TextDataInput
                            value={componentInstance === ARTISTS_KEY && objectKey === WORK_ARTIST_NUMBER_KEY ? (value && value.number ? value.number : value) : value}
                            fieldName={stateKey}
                            changeData={(value, stateKey) =>
                                changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)
                            }
                            readOnly={isReadOnly}
                            maxLength={getMaxLength(objectKey)}
                            isHidden={isHidden}
                            objectKey={objectKey}
                        />
                    </div>
                );
            }
        case INTEGER_PERCENTAGE_INPUT:
            if (objectKey === "creatorRetainedPerShare" || objectKey === "publisherRetainedPerShare" || objectKey === "creatorRetainedMechShare" || objectKey === "publisherRetainedMechShare") {
                return (
                    <div className="tableCell">
                        <InputNumber
                            value={value}
                            min={0}
                            max={100}
                            onKeyDown={handleKeyDown}
                            precision={2}
                            step={10.00}
                            readOnly={isReadOnly}
                            onChange={(value) => changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)}
                            disabled={!isdisabledperfield}
                        />
                    </div>
                )
            }
            else {
                return (
                    <div className="tableCell">
                        <InputNumber
                            value={value}
                            min={0}
                            max={100}
                            onKeyDown={handleKeyDown}
                            precision={2}
                            step={10.00}
                            readOnly={isReadOnly}
                            onChange={(value) => changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)}
                        />
                    </div>

                )
            }
        case INTEGER_INPUT:
            return (
                <div className="tableCell">
                    <TextDataInput
                        value={value === 0 ? "0" : value}
                        fieldName={stateKey}
                        changeData={(value, stateKey) =>
                            changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)
                        }
                        readOnly={isReadOnly}
                        maxLength={getMaxLength(stateKey)}
                        isHidden={isHidden}
                        minValueForNumericField={minValueForNumericField}
                    />
                </div>
            );
        case READ_ONLY_INPUT:
            var frontendValue = value;
            if (stateKey == 'productWork' && objectKey == 'musicUsage') {
                let lookup = mapLookupKey(stateKey, objectKey);
                frontendValue = (getLookupValues(lookup, lookupValues).filter(x => x.code == value)[0] || { description: null }).description;
            }

            if (stateKey == 'matchingRepertoireWorks') {
                if (expandedWorkResults && expandedWorkResults.includes(rowIndex)) {
                    return <div className="tableCell">
                        <TextDataInput
                            value={frontendValue.length >= 1 ? frontendValue[0].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                        <TextDataInput
                            value={frontendValue.length >= 2 ? frontendValue[1].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                        <TextDataInput
                            value={frontendValue.length >= 3 ? frontendValue[2].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                    </div>
                } else {
                    return <div className="tableCell">
                        <TextDataInput
                            value={frontendValue.length >= 1 ? frontendValue[0].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                    </div>
                }
            }

            if (stateKey == 'matchingRepertoireProducts') {
                if (expandedProductResults && expandedProductResults.includes(rowIndex)) {
                    return <div className="tableCell">
                        <TextDataInput
                            value={frontendValue.length >= 1 ? frontendValue[0].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                        <TextDataInput
                            value={frontendValue.length >= 2 ? frontendValue[1].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                        <TextDataInput
                            value={frontendValue.length >= 3 ? frontendValue[2].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                    </div>
                } else {
                    return <div className="tableCell">
                        <TextDataInput
                            value={frontendValue.length >= 1 ? frontendValue[0].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                    </div>
                }
            }

            if (stateKey == 'matchingRepertoireProducts') {
                if (expandedProductResults && expandedProductResults.includes(rowIndex)) {
                    return <div className="tableCell">
                        <TextDataInput
                            value={frontendValue.length >= 1 ? frontendValue[0].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                        <TextDataInput
                            value={frontendValue.length >= 2 ? frontendValue[1].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                        <TextDataInput
                            value={frontendValue.length >= 3 ? frontendValue[2].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                    </div>
                } else {
                    return <div className="tableCell">
                        <TextDataInput
                            value={frontendValue.length >= 1 ? frontendValue[0].value : ''}
                            fieldName={stateKey}
                            changeData={null}
                            readOnly={true}
                            isHidden={isHidden}
                        />
                    </div>
                }
            }

            return (
                <div className="tableCell">
                    <TextDataInput
                        value={frontendValue}
                        fieldName={stateKey}
                        changeData={null}
                        readOnly={true}
                        isHidden={isHidden}
                    />
                </div>
            );
        case DROPDOWN_INPUT:
            let options;
            let lookup;
            if (stateKey === USAGE_DETAILS_ROWS_SECTION_KEY) {
                lookup = mapUsageLookupKey(stateKey, objectKey);
            } else {
                lookup = mapLookupKey(stateKey, objectKey);
            }
            if (objectKey === DISTRIBUTION_POOL_CODE_STATE_KEY) {
                options = !!poolCodes ? poolCodes.map(pc => { return { code: pc, description: pc } }) : null;
            }
            else if (objectKey === 'workName') {
                if (tableContents[rowIndex]['productName'].value !== '') {
                    options = tableContents[rowIndex].productWorks ? tableContents[rowIndex].productWorks.map(each => ({ code: each.title, description: each.title })) : []
                }
                else {
                    options = []
                }
            }
            else if (objectKey === 'distribution') {
                options = !!distributions ? distributions.map(d => ({ code: d.distributionCode, description: d.distributionCode })) : null;
            }
            else if (objectKey === 'pool') {
                if (tableContents[rowIndex]['distribution'].value !== '') {
                    let distribution = !!distributions ? distributions.find(x => x.distributionCode === tableContents[rowIndex]['distribution'].value) : null;
                    if (distribution && distribution.distributionPools)
                        options = (distribution.distributionPools.map(dp => dp.poolCode)).map(poolCode => ({ code: poolCode, description: poolCode }));
                }
                else {
                    options = [];
                    if (tableContents[rowIndex]['pool'].value !== '')
                        changeTableData('', stateKey, 'pool', rowIndex)
                }
            }
            else if (objectKey === 'segment') {
                if (tableContents[rowIndex]['distribution'].value !== '' && tableContents[rowIndex]['pool'].value !== '') {
                    let pools = distributions.find(x => x.distributionCode === tableContents[rowIndex]['distribution'].value).distributionPools.filter(x => x.poolCode === tableContents[rowIndex]['pool'].value);
                    options = pools.map(p => ({ code: p.segment, description: p.segment }));
                }
                else {
                    options = [];
                    if (tableContents[rowIndex]['segment'].value !== '')
                        changeTableData('', stateKey, 'segment', rowIndex)
                }

            }
            else if (objectKey === 'economicRights' && componentInstance !== IP_REPRESENTATION_KEY) {
                const currentMatch = (x: any): boolean => x.extraFields['SetTypeCode'] === tableContents[rowIndex]['shareSet'].value || !x.extraFields['SetTypeCode'];
                if (rowIndex > 0) {
                    options = getLookupValues(lookup, lookupValues).filter(x => x.typeID > 0 && currentMatch(x));
                } else {
                    options = getLookupValues(lookup, lookupValues).filter(x => currentMatch(x));
                }
            }
            else if (objectKey === 'economicRights' && componentInstance === IP_REPRESENTATION_KEY) {
                options = getLookupValues(SET_TYPE_RIGHTS_LOOKUP, lookupValues).filter(x => x.typeID > 0);

            }
            else if (objectKey === 'shareSet' && componentInstance === IP_REPRESENTATION_KEY) {
                options = getLookupValues(SET_TYPE_LOOKUP, lookupValues).filter(x => x.typeID < 0);

            }
            else if (objectKey === 'societyName' && componentInstance === IP_REPRESENTATION_KEY) {
                options = getLookupValues(AGENCY_LOOKUP, lookupValues);

            }
            else if (objectKey === 'role' && componentInstance === IP_REPRESENTATION_KEY) {
                const creationClass = tabs[activeTab].interestedPartyMaintenanceState?.interestedParty?.socIP?.ipRepresentations[rowIndex].creationClass?.value ? tabs[activeTab].interestedPartyMaintenanceState?.interestedParty?.socIP?.ipRepresentations[rowIndex].creationClass?.value : '';

                return <div>
                    <IPRoleSelector
                        fieldValue={value}
                        lookupValues={lookupValues}
                        changeData={(value, stateKey) => {
                            if (value) {
                                changeTableData(value, stateKey, objectKey, rowIndex)
                            }
                        }}
                        creationClassValue={creationClass}
                    />
                </div>
            }
            else if (objectKey === 'includeTerritories' && componentInstance === IP_REPRESENTATION_KEY) {
                options = getLookupValues(TERRITORY_LOOKUP, lookupValues);
            }
            else if (objectKey === 'excludeTerritories' && componentInstance === IP_REPRESENTATION_KEY) {
                options = getLookupValues(TERRITORY_LOOKUP, lookupValues);
            }


            else if (objectKey === PAYMENTRUN_DISTRIBUTION_CODE_STATE_KEY) {
                options = !!distributionCodes ? [...new Set(distributionCodes)].map(pc => { return { code: pc, description: pc } }).sort((a, b) => a.code.localeCompare(b.code, undefined, { sensitivity: 'base' })) : null;
            }
            else if (objectKey === USAGE_DETAILS_ROWS_INBOUNDFEESINERROR || objectKey === USAGE_DETAILS_ROWS_OUTBOUNDFEESINERROR) {
                options = getLookupValues(lookup, lookupValues)
            }
            else if (objectKey === 'effectiveDateRange') {

                const dateRange = datesAndDimensions.map(element => { return { code: element.effectiveDateRange, description: element.effectiveDateRange } });
                options = dateRange;
            }
            else if (objectKey === 'creationClass') {
                options = creationClassOptions.map((element) => ({ code: element.text, description: element.text }));
                options = options.filter(option => option.code !== 'All');
            }

            else {

                options = objectKey === "countryOfOrigin" ? getLookupValues(lookup, lookupValues).filter(x => x.code.length <= 2) :
                    objectKey === 'shareSet' ? getLookupValues(lookup, lookupValues, objectKey) :
                        getLookupValues(lookup, lookupValues, null, portalType)
            }

            let isShowAsCode = objectKey === "countryOfOrigin" || objectKey === "economicRights" ? true : showDropdownsAsCodes

            let readOnly: boolean = isReadOnly

            if (objectKey === "workName" && tableContents[rowIndex]['productName'].value === '') {
                readOnly = true
            }
            if (objectKey === "exclusionUntil") {
                readOnly = false;
            }
            if (objectKey === "senderRep") {
                isShowAsCode = false;
            }
            if (objectKey === "language") {
                isShowAsCode = false;
                options = options.sort((a, b) => a.description.localeCompare(b.description));
            }
            let className = objectKey === 'avRipRoleCode' ? EMPTY_STRING_VALUE : 'tableCell';


            if (lookup === 'WorkNumber' && objectKey === 'type') {
                options = options.filter(x => { return x.extraFields.CoreOrExternal.toUpperCase() === WORKNUMBER_CORE_OR_EXTERNAL_BOTH || x.extraFields.CoreOrExternal.toUpperCase() === WORKNUMBER_CORE_OR_EXTERNAL_CORE })
            }
            if (objectKey === "societyOfLicense") {
                isShowAsCode = false;
                //tableContents[rowIndex]['societyOfLicense'].value = value;
                //var x = value;
                options = options.sort((a, b) => a.description.localeCompare(b.description));
            }
            if (objectKey === 'type' && stateKey === 'applicableWorks') {
                readOnly = true;
            }
            else if (objectKey === 'economicRights' && componentInstance === IP_REPRESENTATION_KEY) {
                readOnly = false;
            }
            if (objectKey === 'avRipRoleCode' && stateKey === 'productContributor') {
                let result = [{ code: "", description: "" }];
                options.map(x => {
                    let value = x.description.split('-')
                    result.push({ code: x.code, description: value[0] })
                });
                options = result;
            }
            return (
                <div className={className}>
                    {(objectKey !== DISTRIBUTION_POOL_CODE_STATE_KEY) ? <DropdownDataInput
                        value={value}
                        options={options}
                        changeData={(value, stateKey) =>
                            changeTableData(value, stateKey, objectKey, rowIndex)
                        }
                        fieldName={stateKey}
                        allowNull={true}
                        showDropdownsAsCodes={isShowAsCode}
                        readOnly={readOnly}
                        isHidden={isHidden}
                        customer={customer}
                    /> : <>
                        <div className="gridContainer">
                            <DropdownDataInput
                                value={value}
                                options={options}
                                changeData={(value, stateKey) =>
                                    changeTableData(value, stateKey, objectKey, rowIndex)
                                }
                                fieldName={stateKey}
                                allowNull={true}
                                showDropdownsAsCodes={isShowAsCode}
                                readOnly={readOnly}
                                isHidden={isHidden}
                                backendSearch={isBackendSearchEnabled}
                                onBackendSearch={onBackendSearch}
                                customer={customer}
                            />
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--OpenInNewTab"}
                                text={""}
                                onClick={() => openInNewTab(tableContentItem)}
                                disabled={isReadOnly}
                            />
                        </div>
                    </>}
                </div>
            );
        case DATE_INPUT:
            return (
                <div className="tableCell">
                    <SizedDateDataInput
                        value={value}
                        fieldName={stateKey}
                        label={undefined}
                        changeData={(value, stateKey) =>
                            changeTableData(value, stateKey, objectKey, rowIndex)
                        }
                        readOnly={isReadOnly}
                        isHidden={isHidden}
                    />
                </div>
            );
        case TIME_INPUT:
            return (
                <>
                    {<SimpleTimeDataInput
                        value={value}
                        changeData={(value, stateKey) => changeTableData(value, stateKey, objectKey, rowIndex)}
                        fieldName={stateKey}
                        label={''}
                        readonly={isReadOnly}
                    />}
                </>
            );
        case TIMESPAN_INPUT:
            return (<div className="tableCell">
                <FormattedTimeDataInput
                    fieldName={objectKey}
                    label=""
                    value={value}
                    changeData={(value, stateKey) =>
                        changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)
                    }
                    readOnly={isReadOnly}
                    tabs={tabs}
                    activeTab={activeTab}
                    isHidden={isHidden}
                    isDataGridSize={true}
                />
            </div>
            );
        case READ_ONLY_TIMESPAN_INPUT:
            return (<div className="tableCell">
                <FormattedTimeDataInput
                    fieldName={objectKey}
                    label=""
                    value={value}
                    changeData={(value, stateKey) =>
                        changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)
                    }
                    readOnly={true}
                    tabs={tabs}
                    activeTab={activeTab}
                    isHidden={isHidden}
                    isDataGridSize={true}
                />
            </div>
            );
        case BOOLEAN_READONLY_INPUT:
            return <BooleanReadonlyDisplay value={value} />
        case CHECKBOX_INPUT:
            return (componentInstance === EDITABLE_FIELDS && objectKey === "isMandatory") ? (
                <div className="tableCell">
                    <CheckboxDataInput
                        label="Is Mandatory"
                        fieldName={stateKey}
                        value={tableContentItem["isMandatory"]}
                        changeData={(value, stateKey) =>
                            changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)}
                        readonly={false}
                        isHidden={isHidden}
                    />
                </div>) : (
                <div className="tableCell">
                    <CheckboxDataInput
                        label=""
                        fieldName={stateKey}
                        value={value}
                        changeData={(value, stateKey) =>
                            changeTableData(value, stateKey, objectKey, rowIndex)}
                        readonly={isReadOnly}
                        isHidden={isHidden}
                    />
                </div>);
        case TOGGLE_BUTTON:
            return (componentInstance === EDITABLE_FIELDS && objectKey === "isHiddenField") ? (
                <ToggleButtonDataInput
                    changeData={(value, stateKey) =>
                        changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)}
                    fieldName={tableContentItem.name}
                    value={tableContentItem.hidden}
                    label={undefined}
                    readonly={isReadOnly}
                    disabled={!tableContentItem["isMandatoryModifiable"] || tableContentItem["isMandatory"]}
                />
            ) : (
                <ToggleButtonDataInput
                    changeData={(value, stateKey) =>
                        changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)}
                    fieldName={tableContentItem.name}
                    value={tableContentItem.hidden}
                    label={undefined}
                    readonly={isReadOnly}

                />
            );
        case CUSTOM_INPUT:
            if (customFields && customFields.includes(rowIndex)) {
                if (objectKey === "workInstruments") {
                    let lookup = mapLookupKey(stateKey, objectKey);
                    let instrumentsOptions = [];
                    const instrumentLookups = getLookupValues(lookup, lookupValues);
                    instrumentLookups.forEach(x => instrumentsOptions.push({ key: x.typeID, text: x.description, data: x.code }));

                    let mappedValues: number[] = [];
                    instrumentLookups.forEach(function (x) {
                        if (value && value.filter(y => y.instrument.value === x.code || y.instrument === x.code).length > 0) {
                            mappedValues.push(x.typeID);
                        }
                    });

                    return (
                        <div className="tableCell">
                            <Dropdown
                                data-testid="workInstruments-custom-dropdown"
                                selectedKeys={mappedValues}
                                options={instrumentsOptions}
                                multiSelect={true}
                                onChange={multiSelectChangeData}
                                placeholder={"No Instruments selected."}
                                disabled={isReadOnly}
                            />
                        </div >
                    )
                } else {
                    return (
                        <div className={tableCell}>
                            <TextDataInput
                                value={value}
                                fieldName={stateKey}
                                changeData={(value, stateKey) =>
                                    changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)
                                }
                                readOnly={isReadOnly}
                                maxLength={getMaxLength(objectKey)}
                                isHidden={isHidden}
                            />
                        </div>
                    )
                }
            }
            else {
                if (objectKey === "workInstruments") {
                    let lookup = mapLookupKey(stateKey, objectKey);
                    let instrumentsOptions = [];
                    const instrumentLookups = getLookupValues(lookup, lookupValues);
                    instrumentLookups.forEach(x => instrumentsOptions.push({ key: x.typeID, text: x.description, data: x.code }));

                    return (
                        <div className="tableCell">
                            <Dropdown
                                data-testid="workInstruments-dropdown"
                                selectedKeys={value}
                                options={instrumentsOptions}
                                multiSelect={true}
                                onChange={multiSelectChangeData}
                                placeholder={"N/A"}
                                disabled={true}
                            />
                        </div >
                    )
                } else {
                    return (
                        <div className={tableCell}>
                            <TextDataInput
                                value={value}
                                fieldName={stateKey}
                                changeData={(value, stateKey) =>
                                    changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)
                                }
                                readOnly={true}
                                maxLength={getMaxLength(objectKey)}
                                isHidden={isHidden}
                            />
                        </div>
                    )
                }
            }
        case DROPDOWN_TREE_INPUT: {
            let readOnly: boolean = isReadOnly;
            let currentMatchType = tableContentItem.value ? lookupSources.find(x => x.id === tableContentItem.value).matchType : null;
            let currentValue = value;
            let options: ITreeData[] = lookupSources;
            if (objectKey === 'source') {
                if (!tableContents[rowIndex]['usageType'].value) {
                    options = [];
                    readOnly = true;
                }
                else {
                    options = lookupSources.filter(x => x.matchType === tableContents[rowIndex]['usageType'].value)
                    if (currentMatchType != tableContents[rowIndex]['usageType'].value) {
                        currentValue = null;
                        tableContents[rowIndex].hierarchy.value = '';
                    }
                }
            }

            return (
                <div className="tableCell">
                    <DropdownTreeDataInput
                        options={options}
                        readOnly={false}
                        fieldName={stateKey}
                        changeData={(value, stateKey) =>
                            changeTableData(value, stateKey, objectKey, rowIndex, componentInstance)}
                        value={currentValue}
                        isHidden={isHidden}
                        allowNull={false}
                    />
                </div>
            )
        }
        case LINK_INPUT:
            return (
                <><Space onClick={() => onClickAddUsageDetails(rowIndex)} size="middle"><a>Add Adjustment Details</a></Space></>
            )
        default:
            if (objectKey === 'date' || objectKey === "submissionDateTime") {
                return (<div className="tableCell">
                    <DateDisplay value={value} showTime={true} />
                </div>)
            }
            if ((objectKey === "fromDate" || objectKey === "toDate") && componentInstance === "ipAgreements") {
                return (<div className="tableCell">
                    <DateDisplay value={value} showTime={false} />
                </div>)
            }
            if ((objectKey === "createdDate" || objectKey === "amendedDateTime") && componentInstance === "ipNames") {
                return (<div className="tableCell">
                    <DateDisplay value={value} showTime={true} />
                </div>)
            }
            if (stateKey === USAGE_DETAILS_ROWS_SECTION_KEY && objectKey === "amount" && tableContentItem === "0E-18") {
                tableContentItem = 0;
            }

            if (objectKey !== "selectionCriteria") {
                return (
                    <div className="tableCell">
                        <DataGridTableSection
                            data={objectKey === IP_NAME_NUMBER_STATE_KEY ? RepertoireHelper.zeroPaddedIPINameNumber(tableContentItem) :
                                (typeof (tableContentItem) === 'string' || typeof (tableContentItem) === 'number' ? tableContentItem :
                                    tableContentItem.value)}
                            title={objectKey === ECONOMIC_RIGHT ? divTitle : undefined} />
                    </div>
                );
            }
    }
};
